import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, " Alterar Link ", -1)
const _hoisted_3 = { class: "pt-3 pb-2 mb-3 border-bottom" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Nome Sistema", -1)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "URL Interno", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "URL Externo", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Fornecedor", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Image", -1)
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary mb-3" }, "Salvar", -1)
const _hoisted_18 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_19 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_20 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_23 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_24 = { class: "btn btn-outline-secondary" }
const _hoisted_25 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_26 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_27 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_28 = { class: "table-responsive mb-4" }
const _hoisted_29 = { class: "table table-striped table-sm" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Selecionar "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " # "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Email "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Login "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Status ")
  ])
], -1)
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mb-4"
}
const _hoisted_33 = { class: "row g-4" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_36 = { class: "btn btn-outline-secondary" }
const _hoisted_37 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_38 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_39 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_40 = { class: "table-responsive mb-4" }
const _hoisted_41 = { class: "table table-striped table-sm" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Selecionar "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " # "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Email "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Login "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Status ")
  ])
], -1)
const _hoisted_43 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ImageUploadcp = _resolveComponent("ImageUploadcp")!
  const _component_tab = _resolveComponent("tab")!
  const _component_tabs = _resolveComponent("tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar sem Salvar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.short_name) = $event)),
          class: "form-control",
          name: "short_name"
        }, null, 512), [
          [_vModelText, $setup.data.short_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.long_name) = $event)),
          class: "form-control",
          name: "long_name"
        }, null, 512), [
          [_vModelText, $setup.data.long_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.url_interno) = $event)),
          class: "form-control",
          name: "url_interno"
        }, null, 512), [
          [_vModelText, $setup.data.url_interno]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.url_externo) = $event)),
          class: "form-control",
          name: "url_externo"
        }, null, 512), [
          [_vModelText, $setup.data.url_externo]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.fornecedor) = $event)),
          class: "form-control",
          name: "fornecedor"
        }, null, 512), [
          [_vModelText, $setup.data.fornecedor]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.image) = $event)),
            class: "form-control",
            name: "image"
          }, null, 512), [
            [_vModelText, $setup.data.image]
          ]),
          _createVNode(_component_ImageUploadcp, {
            tipo: 1,
            onUploaded: _cache[7] || (_cache[7] = ($event: any) => ($setup.data.image = $event))
          })
        ])
      ]),
      _hoisted_17,
      ($setup.data.msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            ($setup.data.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true),
            ($setup.data.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 32),
    _createVNode(_component_tabs, null, {
      default: _withCtx(() => [
        _createVNode(_component_tab, { title: "Selecionar Usuarios" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("form", {
                onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => ($setup.storeLinkUsers && $setup.storeLinkUsers(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("input", {
                    class: "form-control",
                    placeholder: "Procurar Nome ou Email",
                    onKeyup: _cache[9] || (_cache[9] = ($event: any) => ($setup.search($event.target.value)))
                  }, null, 32)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", _hoisted_24, [
                    _createVNode(_component_font_awesome_icon, { icon: "user-plus" })
                  ])
                ]),
                ($setup.data.msg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      ($setup.data.adduserok)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString($setup.data.msg), 1))
                        : _createCommentVNode("", true),
                      ($setup.data.errorAddUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString($setup.data.msg), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("table", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (user) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: user.id
                        }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.usersSel) = $event)),
                              class: "form-check-input",
                              type: "checkbox",
                              value: user.id
                            }, null, 8, _hoisted_31), [
                              [_vModelCheckbox, $setup.usersSel]
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(user.id), 1),
                          _createElementVNode("td", null, _toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1),
                          _createElementVNode("td", null, _toDisplayString(user.email), 1),
                          _createElementVNode("td", null, _toDisplayString(user.username), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(user.status==='1' ? 'badge bg-primary d-block' : 'badge bg-danger d-block' )
                            }, _toDisplayString(user.status==='1' ? ' Ativo ' : 'Inativo'), 3)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ], 32),
              ($setup.page < $setup.lastPage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-secondary g-2",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_tab, { title: "Usuarios Vinculados" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("form", {
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => ($setup.setLinkUsers && $setup.setLinkUsers(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", _hoisted_36, [
                    _createVNode(_component_font_awesome_icon, { icon: "user-minus" })
                  ])
                ]),
                ($setup.data.msg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      ($setup.data.adduserok)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString($setup.data.msg), 1))
                        : _createCommentVNode("", true),
                      ($setup.data.errorAddUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString($setup.data.msg), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("table", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.usersVincLink, (user) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: user.id
                        }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.excSelUsers) = $event)),
                              class: "form-check-input",
                              type: "checkbox",
                              value: user.id
                            }, null, 8, _hoisted_43), [
                              [_vModelCheckbox, $setup.excSelUsers]
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(user.id), 1),
                          _createElementVNode("td", null, _toDisplayString(user.name), 1),
                          _createElementVNode("td", null, _toDisplayString(user.email), 1),
                          _createElementVNode("td", null, _toDisplayString(user.login), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(user.status==='1' ? 'badge bg-primary d-block' : 'badge bg-danger d-block' )
                            }, _toDisplayString(user.status==='1' ? ' Ativo ' : 'Inativo'), 3)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ], 32)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}